{
  "home": {
    "path": "/"
  },
  "pdp": {
    "path": "/products/{slug}"
  },
  "categories": {
    "path": "/categories"
  },
  "plp": {
    "path": "/search"
  },
  "collection": {
    "path": "/collections/{slug}"
  },
  "account": {
    "path": "/account"
  },
  "stores": {
    "path": "/stores"
  },
  "store-details": {
    "path": "/stores/{slug}"
  },
  "looks": {
    "path": "/looks"
  },
  "reset-password": {
    "path": "/account/reset-password"
  }
}
